/**
 * The files Kanos keeps of a firm (ADR-011): PDF, and images, which the server renders anew
 * (§4). One list for what an upload may be, what the browser offers to pick and what a
 * download is named.
 */
export const STORED_MEDIA_TYPES = ['application/pdf', 'image/png', 'image/jpeg'];
/** The ending of a stored file's name and how a person calls its type. */
const STORED_FILE_TYPES = {
    'application/pdf': { extension: 'pdf', label: 'PDF' },
    'image/png': { extension: 'png', label: 'PNG' },
    'image/jpeg': { extension: 'jpg', label: 'JPEG' },
};
const isStored = (mediaType) => STORED_MEDIA_TYPES.includes(mediaType);
/** The file name ending of a stored file's type; `undefined` for any other type. */
export const storedFileExtension = (mediaType) => isStored(mediaType) ? STORED_FILE_TYPES[mediaType].extension : undefined;
/** How a person calls a stored file's type, „PDF“; `undefined` for any other type. */
export const storedFileLabel = (mediaType) => isStored(mediaType) ? STORED_FILE_TYPES[mediaType].label : undefined;
/** The stored types as a person reads them: „PDF, PNG oder JPEG“. */
export const STORED_FILE_TYPES_TEXT = new Intl.ListFormat('de-DE', { type: 'disjunction' }).format(STORED_MEDIA_TYPES.map((type) => STORED_FILE_TYPES[type].label));
/** The largest upload unless the operator sets another (`UPLOAD_MAX_MB`, ADR-011 §1). */
export const DEFAULT_UPLOAD_MAX_MB = 20;
//# sourceMappingURL=files.js.map